import React from "react";
import Table from "@cloudscape-design/components/table";
import Box from "@cloudscape-design/components/box";
import Header from "@cloudscape-design/components/header";
import Alert from "@cloudscape-design/components/alert";
import Button from "@cloudscape-design/components/button";
import Pagination from "@cloudscape-design/components/pagination";
import DatePicker from "@cloudscape-design/components/date-picker";
import SpaceBetween from "@cloudscape-design/components/space-between";
import Select from "@cloudscape-design/components/select";
import Input from "@cloudscape-design/components/input";
/* Recoil */
import { useRecoilValue, useSetRecoilState } from "recoil";
import { panelPaymentsLogStore } from "../stores/panelPaymentsLog";
import { configStore } from "../stores/config";
import { userStore } from "../stores/access";
import Grid from "@cloudscape-design/components/grid";
import FormField from "@cloudscape-design/components/form-field";

const colorButton = {
	cancel: "gray",
	approve: "yellow",
	reject: "red",
};

class PanelPaymentsLogModal extends React.Component {
	constructor(props) {
		super(props);
	}

	componentWillMount() {
		this.props.setPanelUserLog({
			...this.props.panelUserLog,
			date: "",
			error: {
				text: "",
				code: 0,
				timestamp: 0,
			},
			data: [],
			sorting: {
				primarySortingField: "",
				primaryIsDescending: false,
				secondarySortingField: null,
				secondaryIsDescending: false,
			},
			search: {
				request: "",
			},
			pagination: {
				current: 1,
				total: 0,
				page: 0,
				perPage: 0,
				totalPage: 0,
			},
		});
	}

	sortData(data, primarySortingField, primaryIsDescending, secondarySortingField, secondaryIsDescending, searchRequest) {
		// Фильтрация данных по search.request
		const filteredData = searchRequest
			? data.filter(item =>
				item.request.toLowerCase().includes(searchRequest.toLowerCase())
			)
			: [...data];

		const withdrawalStatusOrder = {
			reject: 2,
			approve: 1,
			cancel: 3,
			No: 9999,
		};

		filteredData.sort((a, b) => {
			let aPrimaryValue, bPrimaryValue, aSecondaryValue, bSecondaryValue;


			switch (primarySortingField) {
				case "login":
					aPrimaryValue = a.login || "";
					bPrimaryValue = b.login || "";
					break;
				case "method":
					aPrimaryValue = a.method || "";
					bPrimaryValue = b.method || "";
					break;
				case "project":
					aPrimaryValue = a.request ? JSON.parse(a.request).project || 0 : 0;
					bPrimaryValue = b.request ? JSON.parse(b.request).project || 0 : 0;
					break;
				case "request":
					aPrimaryValue = a.request || "";
					bPrimaryValue = b.request || "";
					break;
				case "withdrawal_status":
					aPrimaryValue = a.withdrawal_status || "No";
					bPrimaryValue = b.withdrawal_status || "No";
					aPrimaryValue = withdrawalStatusOrder[aPrimaryValue] || 999;
					bPrimaryValue = withdrawalStatusOrder[bPrimaryValue] || 999;
					break;
				case "deposit_opened":
					aPrimaryValue = a.deposit_opened || "No";
					bPrimaryValue = b.deposit_opened || "No";
					break;
				case "withdrawal_opened":
					aPrimaryValue = a.withdrawal_opened || "No";
					bPrimaryValue = b.withdrawal_opened || "No";
					break;
				case "sessions_opened":
					aPrimaryValue = a.sessions_opened || "No";
					bPrimaryValue = b.sessions_opened || "No";
					break;
				case "scroll":
					aPrimaryValue = a.scroll || "No";
					bPrimaryValue = b.scroll || "No";
					break;
				case "duration_seconds":
					aPrimaryValue =
						a.duration_seconds === 300 &&
						a.deposit_opened === "No" &&
						a.scroll === "No" &&
						a.withdrawal_opened === "No"
							? "No"
							: a.duration_seconds;
					bPrimaryValue =
						b.duration_seconds === 300 &&
						b.deposit_opened === "No" &&
						b.scroll === "No" &&
						b.withdrawal_opened === "No"
							? "No"
							: b.duration_seconds;
					if (aPrimaryValue === "No") aPrimaryValue = -1;
					if (bPrimaryValue === "No") bPrimaryValue = -1;
					break;
				case "start_time":
					aPrimaryValue = new Date(a.start_time).getTime();
					bPrimaryValue = new Date(b.start_time).getTime();
					break;
				case "end_time":
					aPrimaryValue = new Date(a.end_time).getTime();
					bPrimaryValue = new Date(b.end_time).getTime();
					break;
				default:
					aPrimaryValue = 0;
					bPrimaryValue = 0;
			}

			// Compare primary values
			let primaryComparison;
			if (typeof aPrimaryValue === "string") {
				primaryComparison = primaryIsDescending
					? bPrimaryValue.localeCompare(aPrimaryValue)
					: aPrimaryValue.localeCompare(bPrimaryValue);
			} else {
				primaryComparison = primaryIsDescending
					? bPrimaryValue - aPrimaryValue
					: aPrimaryValue - bPrimaryValue;
			}

			// If primary values are equal and secondary sorting is defined, apply secondary sorting
			if (primaryComparison === 0 && secondarySortingField) {
				switch (secondarySortingField) {
					case "login":
						aSecondaryValue = a.login || "";
						bSecondaryValue = b.login || "";
						break;
					case "method":
						aSecondaryValue = a.method || "";
						bSecondaryValue = b.method || "";
						break;
					case "project":
						aSecondaryValue = a.request ? JSON.parse(a.request).project || 0 : 0;
						bSecondaryValue = b.request ? JSON.parse(b.request).project || 0 : 0;
						break;
					case "request":
						aSecondaryValue = a.request || "";
						bSecondaryValue = b.request || "";
						break;
					case "withdrawal_status":
						aSecondaryValue = a.withdrawal_status || "No";
						bSecondaryValue = b.withdrawal_status || "No";
						aSecondaryValue = withdrawalStatusOrder[aSecondaryValue] || 999;
						bSecondaryValue = withdrawalStatusOrder[bSecondaryValue] || 999;
						break;
					case "deposit_opened":
						aSecondaryValue = a.deposit_opened || "No";
						bSecondaryValue = b.deposit_opened || "No";
						break;
					case "withdrawal_opened":
						aSecondaryValue = a.withdrawal_opened || "No";
						bSecondaryValue = b.withdrawal_opened || "No";
						break;
					case "sessions_opened":
						aSecondaryValue = a.sessions_opened || "No";
						bSecondaryValue = b.sessions_opened || "No";
						break;
					case "scroll":
						aSecondaryValue = a.scroll || "No";
						bSecondaryValue = b.scroll || "No";
						break;
					case "duration_seconds":
						aSecondaryValue =
							a.duration_seconds === 300 &&
							a.deposit_opened === "No" &&
							a.scroll === "No" &&
							a.withdrawal_opened === "No"
								? "No"
								: a.duration_seconds;
						bSecondaryValue =
							b.duration_seconds === 300 &&
							b.deposit_opened === "No" &&
							b.scroll === "No" &&
							b.withdrawal_opened === "No"
								? "No"
								: b.duration_seconds;
						if (aSecondaryValue === "No") aSecondaryValue = -1;
						if (bSecondaryValue === "No") bSecondaryValue = -1;
						break;
					case "start_time":
						aSecondaryValue = new Date(a.start_time).getTime();
						bSecondaryValue = new Date(b.start_time).getTime();
						break;
					case "end_time":
						aSecondaryValue = new Date(a.end_time).getTime();
						bSecondaryValue = new Date(b.end_time).getTime();
						break;
					default:
						aSecondaryValue = 0;
						bSecondaryValue = 0;
				}

				if (typeof aSecondaryValue === "string") {
					return secondaryIsDescending
						? bSecondaryValue.localeCompare(aSecondaryValue)
						: aSecondaryValue.localeCompare(bSecondaryValue);
				}
				return secondaryIsDescending
					? bSecondaryValue - aSecondaryValue
					: aSecondaryValue - bSecondaryValue;
			}

			return primaryComparison;
		});

		return filteredData;
	}

	render() {
		const { panelUserLog, setPanelUserLog, config, user, styles } = this.props;

		const sortedData = this.sortData(
			panelUserLog.data,
			panelUserLog.sorting.primarySortingField,
			panelUserLog.sorting.primaryIsDescending,
			panelUserLog.sorting.secondarySortingField,
			panelUserLog.sorting.secondaryIsDescending,
			panelUserLog.search.request
		);

		// Options for selecting the primary and secondary sorting columns
		const columnOptions = [
			{ label: "None", value: "" },
			{ label: "User", value: "login" },
			{ label: "Method", value: "method" },
			{ label: "Project", value: "project" },
			{ label: "Request", value: "request" },
			{ label: "Withdrawal Status", value: "withdrawal_status" },
			{ label: "Deposit Opened", value: "deposit_opened" },
			{ label: "Withdrawal Opened", value: "withdrawal_opened" },
			{ label: "Game Session", value: "sessions_opened" },
			{ label: "Scroll", value: "scroll" },
			{ label: "Duration (sec)", value: "duration_seconds" },
			{ label: "Start Time", value: "start_time" },
			{ label: "End Time", value: "end_time" },
		];

		return (
			<>
				{panelUserLog.loaded && panelUserLog.error.text.length ? (
					<Box margin={{ bottom: "m" }}>
						<Alert
							type="error"
							header="Error loading data:"
							children={
								<>
									<Box variant="p">{panelUserLog.error.text}</Box>
									<hr />
									<Box variant="p">
										request error code: {panelUserLog.error.code} | request
										timestamp: {panelUserLog.error.timestamp}
									</Box>
								</>
							}
						/>
					</Box>
				) : (
					<></>
				)}

				<Table
					pagination={
						<Pagination
							disabled={!panelUserLog.loaded}
							currentPageIndex={panelUserLog.pagination.current}
							pagesCount={Math.ceil(sortedData.length / config.panelPaymentsLogStore.perPage)}
							onChange={(page) =>
								setPanelUserLog({
									...panelUserLog,
									pagination: {
										...panelUserLog.pagination,
										current: page.detail.currentPageIndex,
									},
								})
							}
						/>
					}
					onSortingChange={(sorting) => {
						setPanelUserLog({
							...panelUserLog,
							sorting: {
								...panelUserLog.sorting,
								primarySortingField: sorting.detail.sortingColumn.sortingField || "",
								primaryIsDescending: sorting.detail.isDescending || false,
							},
						});
					}}
					columnDefinitions={[
						{ id: "login", header: "User", sortingField: "login", cell: (item) => item.login },
						{ id: "method", header: "Method", sortingField: "method", cell: (item) => item.method },
						{
							id: "project",
							header: "Project",
							sortingField: "project",
							cell: (item) =>
								item.request && JSON.parse(item.request).project ? (
									<img
										className={styles["withdrawalsBrand"]}
										src={
											document.body.classList[0] === "awsui-dark-mode"
												? user.brandsList[JSON.parse(item.request).project - 1].logoDark
												: user.brandsList[JSON.parse(item.request).project - 1].logo
										}
									/>
								) : (
									"N/A"
								),
						},
						{ id: "request", sortingField: "request", header: "Request", cell: (item) => item.request },
						{
							id: "withdrawal_status",
							sortingField: "withdrawal_status",
							header: "Withdrawal Status",
							cell: (item) =>
								item.withdrawal_status ? (
									<Button
										variant="inline-link"
										className={[
											styles["players-search-button"],
											styles["btn"],
											styles[colorButton[item.withdrawal_status.toLowerCase()]],
										].join(" ")}
									>
										{item.withdrawal_status.toLowerCase()}
									</Button>
								) : (
									"No"
								),
						},
						{
							id: "deposit_opened",
							sortingField: "deposit_opened",
							header: "Deposit Opened",
							cell: (item) => item.deposit_opened,
						},
						{
							id: "withdrawal_opened",
							sortingField: "withdrawal_opened",
							header: "Withdrawal Opened",
							cell: (item) => item.withdrawal_opened,
						},
						{
							id: "sessions_opened",
							sortingField: "sessions_opened",
							header: "Game Session",
							cell: (item) => (item.sessions_opened ? item.sessions_opened : "No"),
						},
						{ id: "scroll", sortingField: "scroll", header: "Scroll to Log", cell: (item) => item.scroll },
						{
							id: "duration_seconds",
							header: "Duration (sec)",
							sortingField: "duration_seconds",
							cell: (item) =>
								item.duration_seconds === 300 &&
								item.deposit_opened === "No" &&
								item.scroll === "No" &&
								item.withdrawal_opened === "No"
									? "No"
									: item.duration_seconds,
						},
						{
							id: "start_time",
							sortingField: "start_time",
							header: "Start Time",
							cell: (item) =>
								new Date(item.start_time).toLocaleDateString() +
								" " +
								new Date(item.start_time).toLocaleTimeString(),
						},
						{
							id: "end_time",
							sortingField: "end_time",
							header: "End Time",
							cell: (item) =>
								new Date(item.end_time).toLocaleDateString() +
								" " +
								new Date(item.end_time).toLocaleTimeString(),
						},
					]}
					items={sortedData.slice(
						(panelUserLog.pagination.current - 1) * config.panelPaymentsLogStore.perPage,
						panelUserLog.pagination.current * config.panelPaymentsLogStore.perPage
					)}
					loading={!panelUserLog.loaded}
					sortingColumn={{
						sortingField: panelUserLog.sorting.primarySortingField,
					}}
					sortingDescending={panelUserLog.sorting.primaryIsDescending}
					filter={
						<Box variant="flex" margin={{ bottom: "m" }}>
							<SpaceBetween direction="vertical" size="s">
								<SpaceBetween size="xl" direction="horizontal">
									<FormField label="Search by Request" stretch>
										<Input
											disabled={!panelUserLog.loaded}
											value={panelUserLog.search.request || ""}
											onChange={({ detail }) =>
												setPanelUserLog({
													...panelUserLog,
													search: {
														...panelUserLog.search,
														request: detail.value,
													},
													pagination: {
														...panelUserLog.pagination,
														current: 1,
													},
												})
											}
											placeholder="Enter request"
										/>
									</FormField>
								</SpaceBetween>
								<SpaceBetween direction="horizontal" size="xxl">
									<FormField label="Primary Sort" stretch>
										<Select
											disabled={!panelUserLog.loaded}
											selectedOption={
												columnOptions.find(
													(option) => option.value === panelUserLog.sorting.primarySortingField
												) || { label: "None", value: "" }
											}
											onChange={({ detail }) =>
												setPanelUserLog({
													...panelUserLog,
													sorting: {
														...panelUserLog.sorting,
														primarySortingField: detail.selectedOption.value,
														pagination: {
															...panelUserLog.pagination,
															current: 1,
														},
													},
												})
											}
											options={columnOptions}
											placeholder="Select column"
										/>
									</FormField>
									<FormField label="Primary Order" stretch>
										<Select
											disabled={!panelUserLog.loaded}
											selectedOption={
												panelUserLog.sorting.primaryIsDescending
													? { label: "Descending", value: "desc" }
													: { label: "Ascending", value: "asc" }
											}
											onChange={({ detail }) =>
												setPanelUserLog({
													...panelUserLog,
													sorting: {
														...panelUserLog.sorting,
														primaryIsDescending: detail.selectedOption.value === "desc",
														pagination: {
															...panelUserLog.pagination,
															current: 1,
														},
													},
												})
											}
											options={[
												{ label: "Ascending", value: "asc" },
												{ label: "Descending", value: "desc" },
											]}
											placeholder="Select order"
										/>
									</FormField>
									<FormField label="Secondary Sort" stretch>
										<Select
											disabled={!panelUserLog.loaded}
											selectedOption={
												columnOptions.find(
													(option) => option.value === panelUserLog.sorting.secondarySortingField
												) || { label: "None", value: "" }
											}
											onChange={({ detail }) =>
												setPanelUserLog({
													...panelUserLog,
													sorting: {
														...panelUserLog.sorting,
														secondarySortingField: detail.selectedOption.value,
														pagination: {
															...panelUserLog.pagination,
															current: 1,
														},
													},
												})
											}
											options={columnOptions}
											placeholder="Select column"
										/>
									</FormField>
									<FormField label="Secondary Order" stretch>
										<Select
											disabled={!panelUserLog.loaded}
											selectedOption={
												panelUserLog.sorting.secondaryIsDescending
													? { label: "Descending", value: "desc" }
													: { label: "Ascending", value: "asc" }
											}
											onChange={({ detail }) =>
												setPanelUserLog({
													...panelUserLog,
													sorting: {
														...panelUserLog.sorting,
														secondaryIsDescending: detail.selectedOption.value === "desc",
														pagination: {
															...panelUserLog.pagination,
															current: 1,
														},
													},
												})
											}
											options={[
												{ label: "Ascending", value: "asc" },
												{ label: "Descending", value: "desc" },
											]}
											placeholder="Select order"
										/>
									</FormField>
								</SpaceBetween>
							</SpaceBetween>
							<Box margin={{ top: "m" }}>
								<SpaceBetween direction="horizontal" size="m">
									<DatePicker
										value={panelUserLog.date}
										onChange={(changeDate) =>
											setPanelUserLog({
												...panelUserLog,
												date: changeDate.detail.value,
											})
										}
										placeholder="Date"
									/>
									<Button
										onClick={() =>
											this.props.Interface.loadPanelPaymentsLog(this.props.userId, panelUserLog.date)
										}
										disabled={panelUserLog.date === "" || !panelUserLog.loaded}
									>
										Submit
									</Button>
								</SpaceBetween>
							</Box>

						</Box>
					}
					header={
						<Box margin={{ bottom: "m" }}>
							<Header
								children="Log payments"
								description="Below listed all users has granted access to this panel"
								counter={<>({sortedData.length})</>}
							/>
						</Box>
					}
					empty="No logs were found"
				/>
			</>
		);
	}
}

function withRecoil(Component) {
	return function WrappedComponent(props) {
		const panelUserLog = useRecoilValue(panelPaymentsLogStore);
		const setPanelUserLog = useSetRecoilState(panelPaymentsLogStore);
		const config = useRecoilValue(configStore);
		const setConfig = useSetRecoilState(configStore);
		const user = useRecoilValue(userStore);

		return (
			<Component
				{...props}
				user={user}
				config={config}
				setConfig={setConfig}
				panelUserLog={panelUserLog}
				setPanelUserLog={setPanelUserLog}
			/>
		);
	};
}

export default withRecoil(PanelPaymentsLogModal);